import classNames from 'classnames';
import moment from 'moment';
import React from 'react';
import { statusConverterForWhiteBackground } from 'utils/statusConverter';


const columnData = (statusCode, flag) => {
  return {
    logIdx: {
      colWidth: '50px',
      th: <th rowSpan={2}>No.</th>,
      td: (props) => {
        return <td>{props.index + 1}</td>;
      },
    },
    areaNo: {
      colWidth: '200px',
      th: <th>설비번호</th>,
      td: (props) => {
        return <td>{props.areaNo}</td>;
      },
    },
    areaNm: {
      colWidth: '300px',
      th: <th>설비명</th>,
      td: (props) => {
        return <td>{props.areaNm}</td>;
      },
    },
    modelNo: {
      colWidth: '300px',
      th: <th rowSpan={2}>감지기No.</th>,
      td: (props) => {
        return <td>{props.modelNm}</td>;
      },
    },
    h2: {
      colWidth: '150px',
      th: (
        <th rowSpan={2}>
          수소 <br /> H<sub>2</sub>(%)
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? props.moduleScn === '0' ? 
          <td className={classNames('data-text', props.h2_status)}>
            {props.h2.toFixed(1)}
          </td> : <td>-</td> :
        <td colSpan={props.gasCnt -1}>REPEATER</td>)
      },
    },
    co: {
      colWidth: '150px',
      th: (
        <th rowSpan={2}>
          일산화탄소 <br /> CO(ppm)
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? props.moduleScn === '0' ? <td className={classNames('data-text', props.co_status)}>{props.co}</td> : <td>-</td> : <></>)
      },
    },
    ch4: {
      colWidth: '150px',
      th: (
        <th rowSpan={2}>
          {flag === "0" ? <>폭발성가스 <br /> CH4(%LEL)</> : <>폭발성가스 <br /> CH4(%LEL)</>}
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? props.moduleScn === '0' ? 
          <td className={classNames('data-text', props.ch4_status)}>{props.ch4.toFixed(1)}</td> : <td>-</td> : <></>)
      },
    },
    co2: {
      colWidth: '150px',
      th: (
        <th rowSpan={2}>
          이산화탄소 <br /> CO<sub>2</sub>(%)
        </th>
      ),
      td: (props) => {
        return (statusCode === '0' ? <td className={classNames('data-text', props.co2_status)}>{(props.co2 / 10000)?.toFixed(1)}</td> : <></>)
      },
    },
    status: {
      colWidth: '100px',
      th: <th rowSpan={2}>상태</th>,
      td: (props) => {
        return (statusCode === '0' ? <td>{statusConverterForWhiteBackground(props.status)}</td> : <></>)
      },
    },
    battery: {
      colWidth: '100px',
      th: <th rowSpan={2}>Battery잔량</th>,
      td: (props) => {
        return <td>{Math.floor(props.battery)} %</td>;
      },
    },
    rgstDt: {
      colWidth: '400px',
      th: <th rowSpan={2}>측정시간</th>,
      td: (props) => {
        return <td>{props.rgstDt && moment(props.rgstDt).format('YYYY-MM-DD  HH:mm:ss')}</td>;
      },
    },
  };
}

export default columnData;
